import { Route } from 'react-router-dom';
import React from 'react';

import { ProtectedRoute } from '../shared/auth';

import { CompanyBillingInformation } from './company-billing-info';
import { RoleName } from '../shared/auth/role-name';

function companyBillingInfoRoute() {
  return (
    <ProtectedRoute
      path="/company/billing-information"
      role={RoleName.ROLE_CORPORATE_ADMIN}
      render={(routeProps) => (
        <>
          <Route path={routeProps.match.url} exact>
            <CompanyBillingInformation />
          </Route>
        </>
      )}
    />
  );
}

export { companyBillingInfoRoute };
